module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Don’t Do It, She Likes It")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#introduction"
    }
  }, [_vm._v("Introduction")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#social-media-is-your-parallel-universe-wannabe"
    }
  }, [_vm._v("Social Media Is Your Parallel Universe Wannabe")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#politics-and-biases"
    }
  }, [_vm._v("Politics and Biases")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#biases-in-social-media-in-group-bias-and-confirmation-bias"
    }
  }, [_vm._v("Biases in Social Media: In-Group Bias and Confirmation Bias")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#dunning-kruger-effect"
    }
  }, [_vm._v("Dunning-Kruger Effect")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#lies-about-photoshop-gates"
    }
  }, [_vm._v("Lies About Photoshop Gates")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#that-candid-look"
    }
  }, [_vm._v("That Candid Look")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#the-singing-video"
    }
  }, [_vm._v("The Singing Video")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#i-just-woke-up-i-cant-sleep-i-have-no-sleep"
    }
  }, [_vm._v("I Just Woke Up, I Can’t Sleep, I Have No Sleep")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#judge-not-lest-you-be-judged-the-look"
    }
  }, [_vm._v("Judge Not, Lest You Be Judged, The Look")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#an-einstein-look"
    }
  }, [_vm._v("An Einstein Look")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#beautiful-face-lifestyle-the-photographer-and-the-phantom-job"
    }
  }, [_vm._v("Beautiful Face, Lifestyle, the Photographer and the Phantom Job")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#the-phantom-lover"
    }
  }, [_vm._v("The Phantom Lover")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#money-talks"
    }
  }, [_vm._v("Money Talks")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#drama-queen"
    }
  }, [_vm._v("Drama Queen")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#pregnant-selfie-and-post-baby-selfie-syndrome"
    }
  }, [_vm._v("Pregnant Selfie and Post Baby Selfie Syndrome")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#the-recovery-photo"
    }
  }, [_vm._v("The Recovery Photo")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#unfriend-and-friend"
    }
  }, [_vm._v("Unfriend and Friend")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#the-make-ups-and-the-breaks-ups-on-social-media"
    }
  }, [_vm._v("The Make Ups and the Breaks Ups on Social Media")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#introverts-and-extroverts-on-social-media"
    }
  }, [_vm._v("Introverts and Extroverts on Social Media")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#the-fake-love"
    }
  }, [_vm._v("The Fake Love")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#bragging-about-relationships"
    }
  }, [_vm._v("Bragging About Relationships")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#stealing-identity-and-no-identity"
    }
  }, [_vm._v("Stealing Identity and No Identity")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#celebrities-minions"
    }
  }, [_vm._v("Celebrities’ Minions")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#news-anchor-social-media-hero-and-the-news-breaker"
    }
  }, [_vm._v("News Anchor, Social Media Hero and the News Breaker")])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#food-eyes-and-our-mind"
    }
  }, [_vm._v("Food, Eyes and Our Mind")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#the-mosquitoeses-aka-big-girls-blouse"
    }
  }, [_vm._v("The Mosquitoeses AKA Big Girl’s Blouse")])]), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#the-controversial-sexy-photo"
    }
  }, [_vm._v("The Controversial Sexy Photo")])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#confused-identity-the-pretenders-this-section-is-dedicated-to-many-celebrities-in-some-asian-countries"
    }
  }, [_vm._v("Confused Identity, the Pretenders (this section is dedicated to many celebrities in some Asian countries)")])]), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#variety-of-social-media-parents"
    }
  }, [_vm._v("Variety of Social Media Parents")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#special-dedication-for-selfies",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Special Dedication for Selfies")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#the-attempts",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. The Attempts")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#the-position-and-the-location",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Position and the Location")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#types-of-selfie",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Types of Selfie")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#sexy-selfie",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sexy Selfie")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#dangerous-selfie-or-drop-dead-stupid-selfie",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dangerous Selfie or Drop-Dead Stupid Selfie")])]), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#hollywood-social-media",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hollywood Social Media")])]), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#how-to-spot-someone-jealous-of-you-on-social-media",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Spot Someone Jealous of You on Social Media")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#they-imitate-you",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("They imitate you")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#he-tries-to-compete-with-you",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("He tries to compete with you")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#backhanded-compliments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Backhanded compliments")])]), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#downgrading-your-success-and-achievement",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Downgrading your success and achievement")])]), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#they-will-hate-things-you-love-and-they-love-things-you-hate",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("They will hate things you love, and they love things you hate")])]), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#they-watch-and-spy-on-your-social-media",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("They watch and spy on your social media")])]), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#they-see-you-as-their-rival",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("They see you as their rival")])]), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#they-love-talking-about-your-mistakes-and-enjoy-it",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("They love talking about your mistakes and enjoy it")])]), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#they-dont-want-people-to-admire-you-and-compliment-you",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("They don’t want people to admire you and compliment you")])]), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#they-tell-you-how-successful-happy-smart-and-wealthy-they-are",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("They tell you how successful, happy, smart and wealthy they are")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#the-coded-language-on-social-media",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Coded Language on Social Media")])]), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#most-failed-mistypes-on-social-media",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Most Failed Mistypes on Social Media")])]), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#most-miscellaneous-items-on-social-media",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Most Miscellaneous Items on Social Media")])]), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#the-aftermath-social-media-and-internet-for-us",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Aftermath Social Media and Internet for Us")])]), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#suggestion-to-all-social-media-users-and-countries-to-restore-law-and-order",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suggestion to All Social Media Users and Countries to Restore Law and Order")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#according-to-social-media-companies",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("According to social media companies:")])]), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#according-to-society",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("According to society:")])]), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#just-my-humble-suggestions",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Just my humble suggestions:")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#the-generalisation-of-the-world-on-social-media",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Generalisation of the World on Social Media")])]), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#final-conclusion-and-questions",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Final Conclusion and Questions")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#final-thoughts",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Final Thoughts")])]), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#grand-question-for-you",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grand Question for You")])]), _c('li', {
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#a-note-to-all-dear-world-leaders",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Note to All Dear World Leaders")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#the-countries-that-are-almost-perfect-and-stereotypes-on-social-media",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Countries That Are Almost Perfect and Stereotypes on Social Media")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#special-thanks-to",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Special Thanks To")])]), _c('li', {
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#a-mega-special-thank-you-to",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Mega Special Thank You To")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0